import ENVIRONMENTS from 'constants/enviroments';
import axios from 'axios';

const cepApi = axios.create({ baseURL: ENVIRONMENTS.CEP.BASE_URL });

const searchCep = (cep: string) =>
  cepApi.get(
    `${cep}/?app_key=${ENVIRONMENTS.CEP.APP_KEY}&app_secret=${ENVIRONMENTS.CEP.APP_SECRET}`,
  );

export default searchCep;
